$('.hpe-show-more__button').click(function () {
  $(this)
    .prev('.hpe-show-more')
    .toggleClass('hpe-show-more--active');
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/show-more.js